<template>
  <div class="row mb-4">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="offset-8 col-md-2 text-right">
              <b>Total dos produtos</b>
              <br />
              <b>{{ totals.product_total | decimal }}</b>
            </div>
            <div class="col-md-2 text-right">
              <b>Total da compra</b>
              <br />
              <b>{{ orderTotal | decimal }}</b>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-md-2 text-right">
              <small>Base Calc. Icms</small>
              <br />
              <b>{{ totals.icms_calc_base | decimal }}</b>
            </div>
            <div class="col-md-2 text-right">
              <small>Icms</small>
              <br />
              <b>{{ totals.icms | decimal }}</b>
            </div>
            <div class="col-md-2 text-right">
              <small>Base Calc. Icms St. </small>
              <br />
              <b>{{ totals.icms_st_calc_base | decimal }}</b>
            </div>
            <div class="col-md-2 text-right">
              <small>Icms St. </small>
              <br />
              <b>{{ totals.icms_st | decimal }}</b>
            </div>
            <div class="col-md-2 text-right">
              <small>B. C. IPI </small>
              <br />
              <b>{{ totals.ipi_calc_base | decimal }}</b>
            </div>
            <div class="col-md-2 text-right">
              <small>IPI </small>
              <br />
              <b>{{ totals.ipi | decimal }}</b>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    orderTotal: {},
    products: {
      type: Array,
      required: true,
    },
    invoice: {
      required: true,
    },
  },

  computed: {
    totals() {
      let totals = {
        product_total: 0,
        icms_calc_base: 0,
        icms_aliquot: 0,
        icms: 0,
        icms_st_calc_base: 0,
        icms_st_aliquot: 0,
        icms_st: 0,
        ipi_calc_base: 0,
        ipi_aliquot: 0,
        ipi: 0,
        discount: 0,
        shipping: 0,
        expenses: 0,
        insurance: 0,
        net_total: 0,
      };

      for (let index in this.products) {
        let product = this.products[index];
        totals.product_total +=
          parseFloat(product.quantity) * parseFloat(product.price);
        totals.icms_calc_base += parseFloat(product.icms_calc_base);
        totals.icms_aliquot += parseFloat(product.icms_aliquot);
        totals.icms += parseFloat(product.icms);
        totals.icms_st_calc_base += parseFloat(product.icms_st_calc_base);
        totals.icms_st_aliquot += parseFloat(product.icms_st_aliquot);
        totals.icms_st += parseFloat(product.icms_st);
        totals.ipi_calc_base += parseFloat(product.ipi_calc_base);
        totals.ipi_aliquot += parseFloat(product.ipi_aliquot);
        totals.ipi += parseFloat(product.ipi);
        totals.discount += parseFloat(product.discount);
        totals.shipping += parseFloat(product.shipping);
        totals.expenses += parseFloat(product.expenses);
        totals.insurance += parseFloat(product.insurance);
      }

      totals.net_total +=
        totals.product_total -
        totals.discount +
        totals.icms_st +
        totals.ipi +
        totals.shipping +
        totals.expenses +
        totals.insurance;

      return totals;
    },
  },
};
</script>

<style>
</style>